// Integração do formulário de orçamento com o CRM Pipefine (Supabase).
// Especificação: docs/formulariopadrao.md
//
// Os três valores abaixo são públicos (a chave é a "publishable", que só
// consegue chamar a função submit_quote_request). NUNCA coloque aqui a
// secret key (sb_secret_...) nem a service_role.

// ===== Configuração deste site (seção 1 do formulariopadrao.md) =====
export const SUPABASE_URL = 'https://zdhpxqrjfwjywivduyvm.supabase.co';
export const SUPABASE_KEY = 'sb_publishable_n_LYynqTJ0Qgi6YLgihyYw_1hIK-N5e'; // chave publishable
export const COMPANY_ID = 'aaa2c133-6148-4587-adb1-1113e235c066'; // Sofistic Buffet
// ====================================================================

export const MSG_SUCESSO = 'Pedido enviado! Em breve entraremos em contato com o seu orçamento.';
export const MSG_FALHA = 'Não foi possível enviar agora. Tente novamente em instantes.';

const TIMEOUT_MS = 20000;

// Envia o pedido ao CRM. `dados` deve ter exatamente as 10 chaves p_...
// Resolve com o número da comanda; rejeita com um Error cuja `message` já
// pode ser mostrada ao visitante.
export async function enviarOrcamento(dados) {
  if ([SUPABASE_URL, SUPABASE_KEY, COMPANY_ID].includes('PREENCHER')) {
    console.error('[orçamento] src/lib/crm.js ainda não foi configurado (valores PREENCHER).');
    throw new Error(MSG_FALHA);
  }

  const headers = { apikey: SUPABASE_KEY, 'Content-Type': 'application/json' };
  // Chave anon legada (JWT "eyJ...") também precisa do Authorization.
  if (SUPABASE_KEY.startsWith('eyJ')) headers.Authorization = `Bearer ${SUPABASE_KEY}`;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);

  let res;
  try {
    res = await fetch(`${SUPABASE_URL}/rest/v1/rpc/submit_quote_request`, {
      method: 'POST',
      headers,
      body: JSON.stringify(dados),
      signal: controller.signal,
    });
  } catch (erro) {
    console.error('[orçamento] sem resposta do CRM', erro);
    throw new Error(MSG_FALHA);
  } finally {
    clearTimeout(timer);
  }

  const corpo = await res.json().catch(() => null);
  if (res.ok) return corpo; // número da comanda
  console.error('[orçamento] CRM recusou o pedido', res.status, corpo);
  // 22023 = validação do banco; a mensagem já vem em português.
  throw new Error(corpo?.code === '22023' && corpo.message ? corpo.message : MSG_FALHA);
}
